import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import { ProgressBar } from '@/components/ProgressBar'
import { Button } from '@/components/Button'

export interface CompleteOnboardingCardProps {
  questionsCompleted: boolean
  canManageBilling: boolean
  checkoutUrl: string
  onSubmit: () => void
  onEditResponses: () => void
}

export function CompleteOnboardingCard({
  questionsCompleted,
  canManageBilling,
  checkoutUrl,
  onSubmit,
  onEditResponses,
}: CompleteOnboardingCardProps) {
  return (
    <Card testId="complete-onboarding-card">
      {questionsCompleted ? (
        <>
          <CardHeader>
            <CardTitle>Review and submit</CardTitle>
          </CardHeader>
          <CardContent>
            <ProgressBar
              bars={[{ progress: 50 }, { progress: 50, style: 'striped' }]}
            />
          </CardContent>
          <CardContent>Review responses and submit the job.</CardContent>
          {canManageBilling && (
            <CardContent compactBottomPadding>
              <Button
                label="Checkout Job"
                variant="default"
                size="wide-slim"
                to={checkoutUrl}
              />
            </CardContent>
          )}
          <CardContent>
            <Button
              label="Submit Job"
              variant="primary"
              block
              onPress={onSubmit}
              testId="complete-onboarding-card-submit-button"
            />
          </CardContent>
        </>
      ) : (
        <>
          <CardHeader>
            <CardTitle>Complete onboarding</CardTitle>
          </CardHeader>
          <CardContent>
            <ProgressBar key={1} bars={[{ progress: 50, style: 'striped' }]} />
          </CardContent>
          <CardContent>
            Capture all outstanding responses to proceed with the job.
          </CardContent>
          <CardContent>
            <Button
              label="Edit Responses"
              block
              variant="primary"
              onPress={onEditResponses}
              testId="complete-onboarding-card-edit-responses-button"
            />
          </CardContent>
        </>
      )}
    </Card>
  )
}
